<template>
    <b-modal
        :id="'rating-edit-add-section-modal' + rating.id"
        :title="$t('rating.add_section')"
        :ok-disabled="!name"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        modal-class="apprentice-default-modal"
        @show="onShow">
        <!-- name -->
        <div class="new-section">
            <b-form-group
                label-for="section-title-input"
                :label="$t('common.title')">
                <b-form-input
                    id="section-title-input"
                    v-model="name"
                    :placeholder="$t('rating.type_here_the_name_of_the_section')"></b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rating-edit-add-section-modal-component',
    props: ['rating'],
    data() {
        return {
            name: null,
            type: null,
        };
    },
    methods: {
        onOk() {
            let data = {
                type: this.type,
                name: this.name,
                rating_id: this.rating.id,
            };

            this.alert.saving();
            this.axios.post(this.routes.ratingSectionCreate(), data).then(
                (response) => {
                    this.rating.addRelation('sections', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onShow() {
            this.name = null;
        },
    },
};
</script>

<style scoped></style>
